
import { useCallback, useState, useEffect } from 'react';
import AsyncSelect from 'react-select/async';
import { Option } from '../../interface/Option';
import { SayanAxiosInstance } from '../../Network/SayanAxiosInstance';

const ListOfCustomIcds = ({ clear, onChange,defaultValue }: any) => {
  const [cacheOptions, setCacheOptions] = useState<{ [key: string]: Option[] }>(
    {}
  );
  const [selectedOptions, setSelectedOptions] = useState<Option[]>([]);

  const loadOptions = useCallback(
    async (inputValue: string): Promise<Option[]> => {
      if (inputValue.length < 3) {
        return [];
      }

      if (cacheOptions[inputValue]) {
        return cacheOptions[inputValue];
      }

      try {
        const response = await SayanAxiosInstance.put(`getAllDiagnosis/`);
        const data = response.data;

        const options: Option[] = data
          .map((item: any) => ({
            value: item,
            label: item.replace(',', ' |'),
          }))
          .filter((option: Option) =>
            option.label.toLowerCase().includes(inputValue.toLowerCase())
          );

        setCacheOptions((prevCache) => ({
          ...prevCache,
          [inputValue]: options,
        }));

        return options;
      } catch (error) {
        return [];
      }
    },
    [cacheOptions]
  );

  const handleChange = (newValue: any) => {
    setSelectedOptions(newValue || []);
    onChange(newValue || []);
  };

  useEffect(() => {
    if (clear) {
      setSelectedOptions([]);
    }
  }, [clear]);
  useEffect(() => {
    if (defaultValue) {
      setSelectedOptions(defaultValue);
    }
  }, [defaultValue]);
  return (
    <AsyncSelect
      cacheOptions
      className="controlWidth mb-3"
      isMulti
      closeMenuOnSelect={false}
      hideSelectedOptions={false}
      loadOptions={loadOptions}
      onChange={handleChange}
      defaultOptions
      value={selectedOptions} 
      placeholder="Type at least 3 characters to search.."
    />
  );
};

export default ListOfCustomIcds;
